import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BenchmarkingComponent } from './benchmarking.component';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CustomCheckboxdropdownModule } from 'src/app/shared/components/custom-checkboxdropdown/custom-checkboxdropdown.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { ExpansionPanelModule } from 'src/app/shared/components/expansion-panel/expansion-panel.module';
import { GaugeChartModule } from 'src/app/shared/components/gauge-chart/gauge-chart.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { DonutChartModule } from 'src/app/shared/components/donut-chart/donut-chart.module';
import { BenchmarkingRoutingModule } from './benchmarking-routing.module';
import { ChartModule } from 'angular-highcharts';
import { ChSkeletonComponent } from '../shared/ch-skeleton/ch-skeleton.component';




@NgModule({
  declarations: [
    BenchmarkingComponent
  ],
    exports: [BenchmarkingComponent],
  imports: [
    CommonModule,
    GaugeChartModule,
            DonutChartModule,
          ChartModule,
           CommonModule,
               MaterialModule,
               FormsModule,
               ReactiveFormsModule,
               CustomDropdownModule,
               CustomDatePickerModule,
               MaterialModule,
               CustomTimpickerModule,
               CustomInputModule,
               MatPaginatorModule,
               MatIconModule,
               MatTableModule,
               MatSortModule,
               ExpansionPanelModule,
               CustomCheckboxdropdownModule,
               BenchmarkingRoutingModule,
               ChSkeletonComponent
  ]
})
export class BenchmarkingModule { }
